import {
  differenceInMonths,
  format,
  formatDistance,
  formatDuration,
} from 'date-fns';

const ageInMonths = (
  dob: number | Date | string,
  from: number | Date = Date.now()
) => differenceInMonths(from, new Date(dob));

const monthToStr = (months: number) =>
  formatDuration({ years: Math.floor(months / 12), months: months % 12 });

const distanceFromNow = (date: Date | number) =>
  date < Date.now()
    ? formatDistance(date, Date.now()) + ' ago'
    : 'in ' + formatDistance(date, Date.now());

const shortDate = (date: Date | number) => format(date, 'dd MMM');

const mediumDate = (date: Date | number) => format(date, 'MMM dd yyyy');

const longDate = (date: Date | number) => format(date, 'd MMM yyyy HH:mm');

const fromDOB = (
  dob: Date | string | number,
  to: Date | number = Date.now()
): number => {
  const ageInMonths = differenceInMonths(to, new Date(dob));
  return fromAgeInMonths(ageInMonths);
};

const fromAgeInMonths = (ageInMonths: number): number =>
  Math.max(Math.ceil(ageInMonths / 3), 1);

const TrimesterUtils = {
  fromAgeInMonths,
  fromDOB,
};

export const DateUtils = {
  ageInMonths,
  trimester: TrimesterUtils,
  monthToStr,
  shortDate,
  mediumDate,
  longDate,
  distanceFromNow,
};
